import { render } from "./OrderTable.vue?vue&type=template&id=5cad46ff&scoped=true"
import script from "./OrderTable.vue?vue&type=script&lang=js"
export * from "./OrderTable.vue?vue&type=script&lang=js"

import "./OrderTable.vue?vue&type=style&index=0&id=5cad46ff&lang=scss"
import "./OrderTable.vue?vue&type=style&index=1&id=5cad46ff&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cad46ff"]])

export default __exports__